import React from 'react'

import { AccumulationChartComponent, AccumulationSeriesCollectionDirective, 
  AccumulationSeriesDirective, AccumulationLegend, PieSeries, 
  AccumulationDataLabel, Inject, AccumulationTooltip } from '@syncfusion/ej2-react-charts';

  import { useStateContext } from '../../contexts/ContextProvider';

const Pieoriginal = ({ id, data, legendVisibility, height }) => {
  const { currentMode} = useStateContext();

  return (
    <AccumulationChartComponent
        // datalabel = {{  visible: true  }}
        id={id}
        legendSettings={{ visible: legendVisibility, background: 'white' }}
        background={currentMode === 'Dark' ? '#33373E' : '#fff'}
        height={ height }        
        tooltip={{ enable: true }}

      >
        <Inject services={[ AccumulationLegend, PieSeries, AccumulationDataLabel, AccumulationTooltip ]} />

        <AccumulationSeriesCollectionDirective>

            <AccumulationSeriesDirective 
              name='Sale'
              dataSource ={data}
              xName = 'x'
              yName = 'y'   
              innerRadius = '40%'   
              startAngle={0}
              endAngle={360}
              radius="70%"
              explode
              explodeOffset="10%"
              explodeIndex={2}
              dataLabel={{
                visible: true,
                name: 'text',
                position: 'Inside',
                font: {
                  fontWeight: '600',
                  color: '#fff',
                },
              }}      
          />
          
        </AccumulationSeriesCollectionDirective>
      </AccumulationChartComponent>
    )
}

export default Pieoriginal